import TabSelector from './TabSelector';

export default TabSelector;
